module.exports = __webpack_public_path__ + "static/iphone_vertical-8e92ad1b6205b58e6247b8e140e37dd5.png";